import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { API_BASE } from "../config/api";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatPrice(price, currency = "ZAR") {
  return new Intl.NumberFormat("en-ZA", {
    style: "currency",
    currency: currency,
  }).format(price);
}

export function formatDate(dateString) {
  return new Date(dateString).toLocaleDateString("en-ZA", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export function formatDuration(minutes) {
  if (minutes < 60) {
    return `${minutes} min`;
  }
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return mins > 0 ? `${hours}h ${mins}m` : `${hours}h`;
}

export function formatDurationHours(hours) {
  if (!hours && hours !== 0) {
    return '30 mins';  // Default to 30 mins if not set
  }
  if (hours < 1) {
    return `${Math.round(hours * 60)} mins`;
  }
  return `${hours}h`;
}

export function truncateText(text, maxLength) {
  if (!text || text.length <= maxLength) return text;
  return text.slice(0, maxLength) + "...";
}

export function getInitials(name) {
  if (!name) return "?";
  return name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
}

export function calculateCPDProgress(earned, required) {
  if (required <= 0) return 100;
  return Math.min((earned / required) * 100, 100);
}

const DEFAULT_THUMBNAIL = "https://images.unsplash.com/photo-1705234384669-c6d31c61b789?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxsZWFkZXJzaGlwJTIwYnVzaW5lc3MlMjBjb3Vyc2V8ZW58MHx8fHwxNzc0NDQ4NjUxfDA&ixlib=rb-4.1.0&q=85";

export function getThumbnailUrl(url) {
  if (!url) return DEFAULT_THUMBNAIL;
  if (url.startsWith('/api/files/')) {
    return `${API_BASE}${url.replace('/api/files/', '/api/public/files/')}`;
  }
  if (url.startsWith('/api/public/files/')) {
    return `${API_BASE}${url}`;
  }
  return url;
}
